<script setup lang="ts">
import type { PopoverRootEmits, PopoverRootProps } from 'radix-vue'
import { PopoverRoot, useForwardPropsEmits } from 'radix-vue'

const props = defineProps<PopoverRootProps>()
const emits = defineEmits<PopoverRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <PopoverRoot v-bind="forwarded">
    <template #default="{ open }">
      <div
        v-if="open"
        class="fixed top-0 left-0 bottom-0 right-0 z-[9999] pointer-events-auto"
        @click.stop
      />
      <slot />
    </template>
  </PopoverRoot>
</template>
